import React, { FC, ReactNode } from "react";

import { Button } from "@mapmycustomers/ui";

import styles from "./NoResults.module.scss";

export interface NoResultsProps {
  action?: ReactNode;
  description: ReactNode;
  onAction?: () => void;
  title: ReactNode;
}

const NoResults: FC<NoResultsProps> = ({ action, description, onAction, title }) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      {action && onAction && (
        <Button onClick={onAction} type="text">
          {action}
        </Button>
      )}
    </div>
  );
};

export default NoResults;
